var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0651 10.2969L22.2938 8H17.707L17.9357 10.2969H22.0651Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.557 9.5L23.3376 11.7031H16.662L16.4426 9.5H11.8027V32H28.1969V9.5H23.557ZM16.4823 16.4349L18.0526 14.7516C19.3138 15.0658 20.7081 15.0646 21.947 14.7516L23.5169 16.4345C23.2122 16.8635 22.6257 16.9777 23.0863 17.7171C23.7496 18.8958 23.8739 19.9951 23.456 20.9844C22.5678 22.9261 20.2977 23.4611 19.9998 23.5515C19.7352 23.4627 17.4368 22.9474 16.5436 20.9844C16.1256 19.9951 16.25 18.8958 16.9133 17.7171C17.3578 16.9685 16.8059 16.881 16.4823 16.4349ZM22.7713 29.1758H14.4041V27.7695H22.7713V29.1758ZM25.5955 29.1758H24.1893V27.7695H25.5955V29.1758ZM25.5955 26.3516H14.4041V24.9453H25.5955V26.3516Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 22.0874C20.755 21.82 21.7825 21.3029 22.1619 20.4334C22.4031 19.8586 22.3045 19.1957 21.8606 18.4067C21.6989 18.1195 21.2656 17.3494 21.6597 16.5054L21.4515 16.2823C20.4949 16.4371 19.5049 16.4371 18.5476 16.2822L18.3395 16.5052C18.7338 17.349 18.3002 18.1193 18.1385 18.4067C17.6936 19.1974 17.5955 19.8615 17.8387 20.4371C18.2477 21.4054 19.5262 21.9244 20.0004 22.0874ZM19.2964 18.8913H20.7026V20.2975H19.2964V18.8913Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.d8a119523d28f8ae94cf9acb69fd0f6b.svg";
export { ForwardRef as ReactComponent };